{
  "LinkReference": {
    "jsonPointer": "",
    "isList": false,
    "referencedMap": "document_data",
    "shouldCollect": true,
    "isRefOwner": true,
    "shouldValidate": true,
    "refTypes": [
      "LinkReference"
    ],
    "path": []
  },
  "Builder.Video": {
    "jsonPointer": "",
    "isList": false,
    "referencedMap": "document_data",
    "shouldCollect": true,
    "isRefOwner": true,
    "shouldValidate": true,
    "refTypes": [
      "Builder.Video"
    ],
    "path": []
  },
  "Builder.Image": {
    "jsonPointer": "",
    "isList": false,
    "referencedMap": "document_data",
    "shouldCollect": true,
    "isRefOwner": true,
    "shouldValidate": true,
    "refTypes": [
      "Builder.Image"
    ],
    "path": []
  },
  "Builder.VectorArt": {
    "jsonPointer": "",
    "isList": false,
    "referencedMap": "document_data",
    "shouldCollect": true,
    "isRefOwner": true,
    "shouldValidate": true,
    "refTypes": [
      "Builder.VectorArt"
    ],
    "path": []
  },
  "Builder.RichText": {
    "jsonPointer": "",
    "isList": false,
    "referencedMap": "document_data",
    "shouldCollect": true,
    "isRefOwner": true,
    "shouldValidate": true,
    "refTypes": [
      "Builder.RichText"
    ],
    "path": []
  },
  "Builder.MenuItems": {
    "jsonPointer": "",
    "isList": false,
    "referencedMap": "document_data",
    "shouldCollect": true,
    "isRefOwner": false,
    "shouldValidate": true,
    "refTypes": [
      "Builder.MenuItems"
    ],
    "path": []
  },
  "Builder.MenuItem": {
    "jsonPointer": "",
    "isList": false,
    "referencedMap": "document_data",
    "shouldCollect": true,
    "isRefOwner": true,
    "shouldValidate": true,
    "refTypes": [
      "Builder.MenuItem"
    ],
    "path": []
  },
  "PageLink": {
    "jsonPointer": "",
    "isList": false,
    "referencedMap": "document_data",
    "shouldCollect": true,
    "isRefOwner": true,
    "shouldValidate": true,
    "refTypes": [
      "PageLink"
    ],
    "path": []
  },
  "ExternalLink": {
    "jsonPointer": "",
    "isList": false,
    "referencedMap": "document_data",
    "shouldCollect": true,
    "isRefOwner": true,
    "shouldValidate": true,
    "refTypes": [
      "ExternalLink"
    ],
    "path": []
  },
  "EmailLink": {
    "jsonPointer": "",
    "isList": false,
    "referencedMap": "document_data",
    "shouldCollect": true,
    "isRefOwner": true,
    "shouldValidate": true,
    "refTypes": [
      "EmailLink"
    ],
    "path": []
  },
  "AnchorLink": {
    "jsonPointer": "",
    "isList": false,
    "referencedMap": "document_data",
    "shouldCollect": true,
    "isRefOwner": true,
    "shouldValidate": true,
    "refTypes": [
      "AnchorLink"
    ],
    "path": []
  },
  "DocumentLink": {
    "jsonPointer": "",
    "isList": false,
    "referencedMap": "document_data",
    "shouldCollect": true,
    "isRefOwner": true,
    "shouldValidate": true,
    "refTypes": [
      "DocumentLink"
    ],
    "path": []
  },
  "PhoneLink": {
    "jsonPointer": "",
    "isList": false,
    "referencedMap": "document_data",
    "shouldCollect": true,
    "isRefOwner": true,
    "shouldValidate": true,
    "refTypes": [
      "PhoneLink"
    ],
    "path": []
  },
  "DynamicPageLink": {
    "jsonPointer": "",
    "isList": false,
    "referencedMap": "document_data",
    "shouldCollect": true,
    "isRefOwner": true,
    "shouldValidate": true,
    "refTypes": [
      "DynamicPageLink"
    ],
    "path": []
  },
  "TextLink": {
    "jsonPointer": "",
    "isList": false,
    "referencedMap": "document_data",
    "shouldCollect": true,
    "isRefOwner": true,
    "shouldValidate": true,
    "refTypes": [
      "TextLink"
    ],
    "path": []
  },
  "LoginToWixLink": {
    "jsonPointer": "",
    "isList": false,
    "referencedMap": "document_data",
    "shouldCollect": true,
    "isRefOwner": true,
    "shouldValidate": true,
    "refTypes": [
      "LoginToWixLink"
    ],
    "path": []
  },
  "WhatsAppLink": {
    "jsonPointer": "",
    "isList": false,
    "referencedMap": "document_data",
    "shouldCollect": true,
    "isRefOwner": true,
    "shouldValidate": true,
    "refTypes": [
      "WhatsAppLink"
    ],
    "path": []
  },
  "AddressLink": {
    "jsonPointer": "",
    "isList": false,
    "referencedMap": "document_data",
    "shouldCollect": true,
    "isRefOwner": true,
    "shouldValidate": true,
    "refTypes": [
      "AddressLink"
    ],
    "path": []
  }
}